import { Link } from 'react-router-dom'
import { Box, Stack } from '@mui/material'
import { CardButton, NewFeatureChip, PageHeader } from '@/components'
import { useNavigation } from '@/components/layouts/app-layout/navigation/use-navigation'
import { useProduct } from '@/context/product'
import { routes } from '@/router'

export function MenuPage() {
  const { product } = useProduct()
  const { menuItems, sidebarCard } = useNavigation()
  const rollbackRoute =
    product === 'credit' ? routes.credit.index : routes.accounting.index

  return (
    <>
      <PageHeader rollbackRoute={rollbackRoute}>Menu</PageHeader>
      <Box mb={2}>{sidebarCard}</Box>

      <Stack gap={1}>
        {menuItems.map((item) => (
          <CardButton
            key={item.name}
            component={Link}
            to={item.route}
            sx={{
              '& > svg': { color: 'secondary.main' },
              display: item.hide ? 'none' : 'flex',
            }}
          >
            <Box display="flex" alignItems="center" gap={1}>
              {item.name}
              {item.isNew && <NewFeatureChip />}
            </Box>
            {item.icon}
          </CardButton>
        ))}
      </Stack>
    </>
  )
}
